import React from "react";
import { createRoot } from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import App from "./app";
import theme from "./theme";

// Critical CSS first - minimal styles needed for initial render
import "./index.css";

// Bootstrap CSS - imported but will be code-split
// The critical bootstrap classes are inlined in index.html
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Icons stylesheet (provides `bi` classes used across the app)
import "bootstrap-icons/font/bootstrap-icons.css";

// Slick carousel CSS - deferred as it's below the fold
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Production overrides to guarantee layout parity with local
import "./styles/production-overrides.css";

// Performance optimization: Report web vitals only in development
if (process.env.NODE_ENV === 'development') {
  import('./reportWebVitals').then(({ default: reportWebVitals }) => {
    reportWebVitals(console.log);
  });
}

createRoot(document.getElementById("root")).render(
  <ChakraProvider theme={theme}>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <App />
  </ChakraProvider>
);
